import React from 'react';
import { Navbar, Nav } from 'rsuite';
import AngleLeftIcon from '@rsuite/icons/legacy/AngleLeft';
import AngleRightIcon from '@rsuite/icons/legacy/AngleRight';

export default function NavToggle({ expand, onChange }) {
  return (
    <Navbar appearance="subtle" className="nav-toggle" style={{ position: 'absolute', bottom: 0, right: 0 }}>
      <Nav pullRight>
        <Nav.Item onClick={onChange} style={{ width: '100%', textAlign: 'center' }}>
          {expand ? <AngleLeftIcon /> : <AngleRightIcon />}
        </Nav.Item>
      </Nav>
    </Navbar>
  );
}